'use client';

import { useEffect } from 'react';

import { getCookie, setCookie } from 'cookies-next';

import { generateUUID } from '@utils/generateUUID';

const SessionInitializer = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    let sessionId = getCookie('sessionId');
    if (!sessionId) {
      sessionId = generateUUID();

      setCookie('sessionId', sessionId, {
        httpOnly: false,
        maxAge: 60 * 60 * 24,
        secure: process.env.NODE_ENV === 'production',
        path: '/',
      });
    }
  }, []);

  return <>{children}</>; // Render the children
};

export default SessionInitializer;
